module.exports = __webpack_public_path__ + "img/api-server.edbe8206.png";